import ModalForm from '../../shared/components/modal-form';

export default class InternshipRatingForm extends ModalForm {
  constructor() {
    super(...arguments);

    this.$confirmationElement = this.$element.find(
      '.internshipRatingForm-confirmation'
    );

    this.bindEvents();
  }

  handleModalShow(event) {
    const $defaultField = this.$element.find('.starRating-defaultValue');
    $defaultField.val($(event.relatedTarget).data('rating'));
    $defaultField.trigger('change');
  }

  handleModalHide() {
    if (this.formWasSuccessful) {
      window.Turbolinks.reload({keepScrollPosition: true});
    }

    super.handleModalHide();
  }

  handleFormSuccess() {
    this.$confirmationElement.show();

    super.handleFormSuccess(...arguments);
  }
}
